export default __webpack_public_path__ + "static/media/slider_4.736cc696.png";